import { guid } from "./guid";

export const setToken = (token: string) =>
  sessionStorage.setItem(`KJ_TOKEN`, token);

export const getToken = () =>
  sessionStorage.getItem(`KJ_TOKEN`);

export const removeToken = () =>
  sessionStorage.removeItem(`KJ_TOKEN`);

export const getUuid = () => {
  const key = `KJ_UUID`;
  let uuid = localStorage.getItem(key);
  if (!uuid) {
    uuid = guid();
    localStorage.setItem(key, uuid);
  }

  return uuid;
};
